import React, { useMemo } from 'react';

import { useFulfillmentPlannerContext } from '../../../../../../fulfillment-planner/context';

import ErrorMessageResolver from './error-message-resolver';
import { CustomsErrorMessage } from './error-message';

export const CustomsErrorsSection = () => {
  const { rateErrors } = useFulfillmentPlannerContext();

  const customsErrors = useMemo(() => {
    return rateErrors?.filter((error) => ErrorMessageResolver.isCustomsErrorMessage(error)) as string[];
  }, [rateErrors]);
  if (!customsErrors || !customsErrors.length) {
    return null;
  }

  return customsErrors.map((error) => <CustomsErrorMessage key={error} error={error} />);
};
